import translations from "../../translations/resources/en-GB.json";
var ERROR_STATUS_CODE = {
    409: {
        code: 409,
        error_message: translations.data["venonboard.internalTools.CreateDraft409Error"],
    },
};
export { ERROR_STATUS_CODE };
export var venueTypes = [
    {
        name: "Academic Building",
        type: "ACADEMIC_BUILDING",
    },
    {
        name: "Airport",
        type: "AIRPORT",
    },
    {
        name: "Apartment Complex",
        type: "APARTMENT_COMPLEX",
    },
    {
        name: "Bus Station",
        type: "BUS_STATION",
    },
    {
        name: "Business Campus",
        type: "BUSINESS_CAMPUS",
    },
    {
        name: "Campground",
        type: "CAMPGROUND",
    },
    {
        name: "Casino",
        type: "CASINO",
    },
    {
        name: "College Campus Building",
        type: "COLLEGE_CAMPUS_BUILDING",
    },
    {
        name: "Convention Center",
        type: "CONVENTION_CENTER",
    },
    {
        name: "Dormitory",
        type: "DORMITORY",
    },
    {
        name: "Government",
        type: "GOVERNMENT",
    },
    {
        name: "High School",
        type: "HIGH_SCHOOL",
    },
    {
        name: "Hospital",
        type: "HOSPITAL",
    },
    {
        name: "Hotel",
        type: "HOTEL",
    },
    {
        name: "Industry",
        type: "INDUSTRY",
    },
    {
        name: "Library",
        type: "LIBRARY",
    },
    {
        name: "Metro Station",
        type: "METRO_STATION",
    },
    {
        name: "Museum",
        type: "MUSEUM",
    },
    {
        name: "Other",
        type: "OTHER",
    },
    {
        name: "Parking Garage",
        type: "PARKING_GARAGE",
    },
    {
        name: "Religious Building",
        type: "RELIGIOUS_BUILDING",
    },
    {
        name: "Retail",
        type: "RETAIL",
    },
    {
        name: "School",
        type: "SCHOOL",
    },
    {
        name: "Shopping Center",
        type: "SHOPPING_CENTER",
    },
    {
        name: "Shopping Mall",
        type: "SHOPPING_MALL",
    },
    {
        name: "Sports Center",
        type: "SPORTS_CENTER",
    },
    {
        name: "Stadium",
        type: "STADIUM",
    },
    {
        name: "Theater",
        type: "THEATER",
    },
    {
        name: "Theme Park",
        type: "THEME_PARK",
    },
    {
        name: "Train Station",
        type: "TRAIN_STATION",
    },
    {
        name: "Urban Park",
        type: "URBAN_PARK",
    },
];
export var languages = [
    {
        name: "Arabic",
        value: "ar",
        local: "العربية",
    },
    {
        name: "Chinese",
        value: "zh",
        local: "中文",
    },
    {
        name: "Chinese (Traditional)",
        value: "zho",
        local: "",
    },
    {
        name: "Danish",
        value: "da",
        local: "Dansk",
    },
    {
        name: "Dutch",
        value: "nl",
        local: "Nederlands",
    },
    {
        name: "English",
        value: "en",
        local: "English",
    },
    {
        name: "French",
        value: "fr",
        local: "Français",
    },
    {
        name: "German",
        value: "de",
        local: "Deutsch",
    },
    {
        name: "Gujarati",
        value: "gu",
        local: "ગુજરાતી",
    },
    {
        name: "Hebrew",
        value: "he",
        local: "עברית",
    },
    {
        name: "Hindi",
        value: "hi",
        local: "हिन्दी",
    },
    {
        name: "Indonesian",
        value: "id",
        local: "Bahasa Indonesia",
    },
    {
        name: "Italian",
        value: "it",
        local: "Italiano",
    },
    {
        name: "Japanese",
        value: "ja",
        local: "日本語",
    },
    {
        name: "Korean",
        value: "ko",
        local: "한국어",
    },
    {
        name: "Portuguese",
        value: "pt",
        local: "Português",
    },
    {
        name: "Romanian",
        value: "ro",
        local: "Română",
    },
    {
        name: "Russian",
        value: "ru",
        local: "Русский",
    },
    {
        name: "Spanish",
        value: "es",
        local: "Español",
    },
    {
        name: "Swedish",
        value: "sv",
        local: "Svenska",
    },
    {
        name: "Turkish",
        value: "tr",
        local: "Türkçe",
    },
];
export var UsaStates = [
    {
        name: "Alabama",
        abbreviation: "AL",
        territory: false,
        capital: "Montgomery",
        contiguous: true,
    },
    {
        name: "Alaska",
        abbreviation: "AK",
        territory: false,
        capital: "Juneau",
        contiguous: false,
    },
    {
        name: "Arizona",
        abbreviation: "AZ",
        territory: false,
        capital: "Phoenix",
        contiguous: true,
    },
    {
        name: "Arkansas",
        abbreviation: "AR",
        territory: false,
        capital: "Little Rock",
        contiguous: true,
    },
    {
        name: "California",
        abbreviation: "CA",
        territory: false,
        capital: "Sacramento",
        contiguous: true,
    },
    {
        name: "Colorado",
        abbreviation: "CO",
        territory: false,
        capital: "Denver",
        contiguous: true,
    },
    {
        name: "Connecticut",
        abbreviation: "CT",
        territory: false,
        capital: "Hartford",
        contiguous: true,
    },
    {
        name: "Delaware",
        abbreviation: "DE",
        territory: false,
        capital: "Dover",
        contiguous: true,
    },
    {
        name: "District Of Columbia",
        abbreviation: "DC",
        territory: false,
        capital: "",
        contiguous: true,
    },
    {
        name: "Florida",
        abbreviation: "FL",
        territory: false,
        capital: "Tallahassee",
        contiguous: true,
    },
    {
        name: "Georgia",
        abbreviation: "GA",
        territory: false,
        capital: "Atlanta",
        contiguous: true,
    },
    {
        name: "Hawaii",
        abbreviation: "HI",
        territory: false,
        capital: "Honolulu",
        contiguous: false,
    },
    {
        name: "Idaho",
        abbreviation: "ID",
        territory: false,
        capital: "Boise",
        contiguous: true,
    },
    {
        name: "Illinois",
        abbreviation: "IL",
        territory: false,
        capital: "Springfield",
        contiguous: true,
    },
    {
        name: "Indiana",
        abbreviation: "IN",
        territory: false,
        capital: "Indianapolis",
        contiguous: true,
    },
    {
        name: "Iowa",
        abbreviation: "IA",
        territory: false,
        capital: "Des Moines",
        contiguous: true,
    },
    {
        name: "Kansas",
        abbreviation: "KS",
        territory: false,
        capital: "Topeka",
        contiguous: true,
    },
    {
        name: "Kentucky",
        abbreviation: "KY",
        territory: false,
        capital: "Frankfort",
        contiguous: true,
    },
    {
        name: "Louisiana",
        abbreviation: "LA",
        territory: false,
        capital: "Baton Rouge",
        contiguous: true,
    },
    {
        name: "Maine",
        abbreviation: "ME",
        territory: false,
        capital: "Augusta",
        contiguous: true,
    },
    {
        name: "Maryland",
        abbreviation: "MD",
        territory: false,
        capital: "Annapolis",
        contiguous: true,
    },
    {
        name: "Massachusetts",
        abbreviation: "MA",
        territory: false,
        capital: "Boston",
        contiguous: true,
    },
    {
        name: "Michigan",
        abbreviation: "MI",
        territory: false,
        capital: "Lansing",
        contiguous: true,
    },
    {
        name: "Minnesota",
        abbreviation: "MN",
        territory: false,
        capital: "Saint Paul",
        contiguous: true,
    },
    {
        name: "Mississippi",
        abbreviation: "MS",
        territory: false,
        capital: "Jackson",
        contiguous: true,
    },
    {
        name: "Missouri",
        abbreviation: "MO",
        territory: false,
        capital: "Jefferson City",
        contiguous: true,
    },
    {
        name: "Montana",
        abbreviation: "MT",
        territory: false,
        capital: "Helena",
        contiguous: true,
    },
    {
        name: "Nebraska",
        abbreviation: "NE",
        territory: false,
        capital: "Lincoln",
        contiguous: true,
    },
    {
        name: "Nevada",
        abbreviation: "NV",
        territory: false,
        capital: "Carson City",
        contiguous: true,
    },
    {
        name: "New Hampshire",
        abbreviation: "NH",
        territory: false,
        capital: "Concord",
        contiguous: true,
    },
    {
        name: "New Jersey",
        abbreviation: "NJ",
        territory: false,
        capital: "Trenton",
        contiguous: true,
    },
    {
        name: "New Mexico",
        abbreviation: "NM",
        territory: false,
        capital: "Santa Fe",
        contiguous: true,
    },
    {
        name: "New York",
        abbreviation: "NY",
        territory: false,
        capital: "Albany",
        contiguous: true,
    },
    {
        name: "North Carolina",
        abbreviation: "NC",
        territory: false,
        capital: "Raleigh",
        contiguous: true,
    },
    {
        name: "North Dakota",
        abbreviation: "ND",
        territory: false,
        capital: "Bismarck",
        contiguous: true,
    },
    {
        name: "Ohio",
        abbreviation: "OH",
        territory: false,
        capital: "Columbus",
        contiguous: true,
    },
    {
        name: "Oklahoma",
        abbreviation: "OK",
        territory: false,
        capital: "Oklahoma City",
        contiguous: true,
    },
    {
        name: "Oregon",
        abbreviation: "OR",
        territory: false,
        capital: "Salem",
        contiguous: true,
    },
    {
        name: "Pennsylvania",
        abbreviation: "PA",
        territory: false,
        capital: "Harrisburg",
        contiguous: true,
    },
    {
        name: "Rhode Island",
        abbreviation: "RI",
        territory: false,
        capital: "Providence",
        contiguous: true,
    },
    {
        name: "South Carolina",
        abbreviation: "SC",
        territory: false,
        capital: "Columbia",
        contiguous: true,
    },
    {
        name: "South Dakota",
        abbreviation: "SD",
        territory: false,
        capital: "Pierre",
        contiguous: true,
    },
    {
        name: "Tennessee",
        abbreviation: "TN",
        territory: false,
        capital: "Nashville",
        contiguous: true,
    },
    {
        name: "Texas",
        abbreviation: "TX",
        territory: false,
        capital: "Austin",
        contiguous: true,
    },
    {
        name: "Utah",
        abbreviation: "UT",
        territory: false,
        capital: "Salt Lake City",
        contiguous: true,
    },
    {
        name: "Vermont",
        abbreviation: "VT",
        territory: false,
        capital: "Montpelier",
        contiguous: true,
    },
    {
        name: "Virginia",
        abbreviation: "VA",
        territory: false,
        capital: "Richmond",
        contiguous: true,
    },
    {
        name: "Washington",
        abbreviation: "WA",
        territory: false,
        capital: "Olympia",
        contiguous: true,
    },
    {
        name: "West Virginia",
        abbreviation: "WV",
        territory: false,
        capital: "Charleston",
        contiguous: true,
    },
    {
        name: "Wisconsin",
        abbreviation: "WI",
        territory: false,
        capital: "Madison",
        contiguous: true,
    },
    {
        name: "Wyoming",
        abbreviation: "WY",
        territory: false,
        capital: "Cheyenne",
        contiguous: true,
    },
];
export var FIELD_ERROR_MESSAGE = {
    POSTAL_CODE_INVALID: translations.data["venonboard.errorMessage.invalidPostCode"],
};
export var style = {
    pointerEvents: "none",
};
export var styleWarning = {
    "--hds-action": "var(--hds-warning)",
    pointerEvents: "none",
};
export var stylePositive = {
    "--hds-action": "var(--hds-positive)",
    pointerEvents: "none",
};
export var iconStyle = {
    "--hds-icon-color": "var(--hds-purple-600)",
};
export var iconStyle3D = {
    "--hds-icon-color": "#9E6400",
};
export var copyIconStyle = {
    "--hds-icon-color": "var(--hds-action)",
};
